import { api } from "../api/config";

const hotelService = {
  // GET ALL HOTELS
  getAll: (params) =>
    api.get("/hotels", {
      params,
    }),

  // GET SINGLE HOTEL
  getById: (id) =>
    api.get(`/hotels/${id}`),

  // CREATE HOTEL
  create: (data) =>
    api.post("/hotels", data),

  // UPDATE HOTEL
  update: (id, data) =>
    api.put(`/hotels/${id}`, data),

  // DELETE HOTEL
  delete: (id) =>
    api.delete(`/hotels/${id}`),

  // HOTEL STATS
  getStats: () =>
    api.get("/hotels/stats"),

  // IMPORT HOTELS CSV
  importHotels: (formData) =>
    api.post(
      "/hotels/import",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    ),

  // UPLOAD HOTEL IMAGES
  uploadImages: (hotelId, formData) =>
    api.post(
      `/hotels/${hotelId}/images`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    ),

  // DELETE HOTEL IMAGE
  deleteImage: (hotelId, imageId) =>
    api.delete(`/hotels/${hotelId}/images/${imageId}`),
};

export default hotelService;
